export default __webpack_public_path__ + "static/media/tour.639e6c92.PNG";